import React from 'react'
import { useForm } from 'react-hook-form'
import { Form } from 'react-bootstrap'
import { Button, Modal, ModalBody, ModalHeader } from 'reactstrap'
import { message } from 'antd'
import moment from 'moment'

import SstPostForm from './SstPostForm'

import { updateSstPost } from '../services'
import { handleError } from '../../../helpers'

export default function EditSstPostModal({ visible, onClose, reload, sstPost }) {
	const { register, handleSubmit, formState: { errors } } = useForm({
		defaultValues: { 
			...sstPost,
			expire_at: moment(sstPost.expire_at).format('YYYY-MM-DD'),
			is_published: sstPost.is_published ? 1 : 0,
		}
	})

	const onSubmit = values => {
		updateSstPost(sstPost.id, values)
			.then(res => {
				message.success(res.data.message)
				reload()
			})
			.catch(error => handleError(error))
	}

	return (
		<React.Fragment>
			<Modal isOpen={visible} toggle={onClose}>
				<ModalHeader toggle={onClose}>Actualizar Registro</ModalHeader>
				<ModalBody>
					<Form onSubmit={handleSubmit(onSubmit)}>
						<SstPostForm register={register} errors={errors} sstPost={sstPost} />
						<Button color="primary" type="submit">Actualizar Registrar</Button>
					</Form>
				</ModalBody>
			</Modal>
		</React.Fragment>
	)
}